module.exports = __webpack_public_path__ + "img/hankey.f09591d8.png";